import React from 'react';
import ReactDOM from 'react-dom';

import "./index.css";

import {ChillApp} from "./ChillApp";

ReactDOM.render(<ChillApp/>,
    document.getElementById('root')
);
